module.exports = __webpack_public_path__ + "static/drawing-footer-075c4ca31390f2979424e5eb21e02bc6.png";